import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabase";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  scrolled: boolean;
}

type Category = {
  id: number;
  name: string;
};

const CategorySlidePanel = ({ isOpen, onClose, scrolled }: Props) => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await supabase.from("Category").select("*");
      if (data) setCategories(data);
      else console.error("Error loading categories:", error);
    };

    fetchCategories();
  }, []);

  const handleClick = (categoryId?: number) => {
    onClose();
    if (categoryId) {
      navigate(`/products?category=${categoryId}`);
    } else {
      navigate("/products?all=true");
    }
  };

  return (
    <div
      onMouseLeave={onClose}
      className={`
        fixed top-0 left-0
        h-screen
        w-72
        bg-gradient-to-b from-white/40 to-[#ffe5e5]/60
        backdrop-blur-md
        shadow-lg border border-white/40
        rounded-tr-3xl rounded-br-3xl
        transform
        transition-all duration-700 ease-in-out
        z-50
        ${isOpen ? "translate-x-0 opacity-100 pointer-events-auto" : "-translate-x-6 opacity-0 pointer-events-none"}
      `}
    >
      <div className="flex justify-between items-center px-4 py-3 border-b border-white/50 bg-white/30 backdrop-blur-sm rounded-tr-3xl">
        <h2 className="text-lg font-semibold text-[#5c2f2f] tracking-wide">
          Categories
        </h2>
        <button
          onClick={onClose}
          className="text-sm text-[#a25d5d] hover:text-[#8f4d4d] transition-transform hover:scale-110"
        >
          ✕
        </button>
      </div>

      <ul className="p-4 space-y-3 text-[#7a4343] font-medium">
        <li
          className="cursor-pointer transition-all hover:text-[#5c2f2f] hover:translate-x-1"
          onClick={() => handleClick(undefined)}
        >
          All Products
        </li>

        {categories.map((cat) => (
          <li
            key={cat.id}
            className="cursor-pointer transition-all hover:text-[#5c2f2f] hover:translate-x-1"
            onClick={() => handleClick(cat.id)}
          >
            {cat.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategorySlidePanel;
